import { debouncedRef } from '@vueuse/core';
import { ref, watch } from 'vue-demi';

// TODO: Use `defineEmits` after migration to Vue 3
function usePopoverState(isOpen, emit) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  // State
  const state = ref(isOpen.value ? 'open' : 'closed');
  watch(isOpen, value => {
    state.value = value ? 'open' : 'closed';
  });
  const debouncedState = options.debounce ? debouncedRef(state, options.debounce) : state;
  watch(debouncedState, value => {
    emit('update:state', value);
    switch (value) {
      case 'open':
        emit('open');
        break;
      case 'closed':
        emit('close');
        break;
    }
  });
  // Methods
  function open() {
    state.value = 'open';
  }
  function close() {
    state.value = 'closed';
  }
  function toggle() {
    state.value = state.value === 'open' ? 'closed' : 'open';
  }
  return {
    state: debouncedState,
    open,
    close,
    toggle
  };
}

export { usePopoverState as u };
